import { Component, Output, EventEmitter } from '@angular/core';
import { CartService } from '../../../../shared/services/cart.service';
import { CartItem } from '../../../../shared/interfaces/cart-item';
import { RootService } from '../../../../shared/services/root.service';
import { SiteViwModel } from '@app/shared/interfaces/SiteViewModel';
import { StoreService } from '@app/shared/services/store.service';

@Component({
    selector: 'app-header-dropcart',
    templateUrl: './dropcart.component.html',
    styleUrls: ['./dropcart.component.scss']
})
export class DropcartComponent {
    removedItems: CartItem[] = [];


    @Output() navgated: EventEmitter<boolean> = new EventEmitter();

    constructor(
        public cart: CartService,
        public root: RootService,
        public store: StoreService
    ) { }

    remove(item: CartItem): void {
        if (this.removedItems.includes(item)) {
            return;
        }

        this.removedItems.push(item);
        this.cart.remove(item).subscribe({complete: () => this.removedItems = this.removedItems.filter(eachItem => eachItem !== item)});
    }

    navgate(nav: boolean): void {

        this.navgated.emit(nav);
    }
    getKeywords(key): string {
        let value = '';
        if (localStorage.getItem('store')) {
            const store = JSON.parse(localStorage.getItem('store')) as SiteViwModel;
            value = store.keywords.find(x => x.key === key).value;
        }
        return value;
    }
}
